import { render, staticRenderFns } from "./SkuMappings.vue?vue&type=template&id=2aea45e0&scoped=true"
import script from "./SkuMappings.vue?vue&type=script&lang=js"
export * from "./SkuMappings.vue?vue&type=script&lang=js"
import style0 from "./SkuMappings.vue?vue&type=style&index=0&id=2aea45e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea45e0",
  null
  
)

export default component.exports